export interface IDTOCampaign {
  campaignId: number;
  subdomain?: string;
  description?: string;
}

export default class Campaign {
  id: number;

  subdomain?: string;

  description?: string;

  constructor(o?: IDTOCampaign) {
    this.id = o?.campaignId ?? 0;
    this.subdomain = o?.subdomain ?? '';
    this.description = o?.description ?? '';
  }

  get value() { return this.id; }

  get text() { return this.description; }
}
